var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.debug)?_c('div',{staticClass:"debug-box"},[_c('button',{staticClass:"debug-box-btn",on:{"click":function($event){$event.preventDefault();_vm.showDebug = !_vm.showDebug}}},[_vm._v("Toggle debug info")]),(_vm.showDebug)?_c('div',[_vm._t("default")],2):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }